export const LEAVING_DISCLAIMER = {
    EXIT: "You are now leaving the DUPIXIENT virtual booth", 
    MAIN_COPY: "To connect with a DUPIXENT Field Representative regarding product-related questions, please click the connect button which will open a new browser window", 
    CONTINUE_BUTTON: "CONNECT", 
    BACK_BUTTON:"CLOSE"
}